export var OptimizationTemplateArchivedStatus;
(function (OptimizationTemplateArchivedStatus) {
    OptimizationTemplateArchivedStatus["ACTIVE"] = "Active";
    OptimizationTemplateArchivedStatus["ARCHIVED"] = "Archived";
    OptimizationTemplateArchivedStatus["BOTH"] = "Both";
})(OptimizationTemplateArchivedStatus || (OptimizationTemplateArchivedStatus = {}));
//# sourceMappingURL=types.js.map